<template>
  <div class="px-3">
    <div class="px-3 container-lg">
      <div style="padding: 20px 0 40px 0">
        <AppBreadcrumb />
      </div>
    </div>
  </div>
</template>

<script>
import AppBreadcrumb from './AppBreadcrumb'
import { logo } from '@/assets/brand/logo'
export default {
  name: 'AppHeader',
  components: {
    AppBreadcrumb,
  },
  setup() {
    return {
      logo,
    }
  },
}
</script>
